import React from 'react';
import { CartTableProduct } from '../CartTableProduct';
import { CartProductQuantity } from '../CartProductQuantity';
import useCartData from '@arctheme-hooks/useCartData';
import { ICart } from '@src/types/cart';

export const TableLayout = ({ settings, cartData }: { settings: any; cartData: ICart }) => {
  const { section, routes } = settings;
  const { cart, fetchCart }: any = useCartData();

  const productLayout = section.product_layout;

  return (
    <table style={{ width: '100%' }}>
      <tbody>
        {/* Subscription Products Section */}
        {cart?.items.filter((item) => item.selling_plan_allocation).length > 0 && (
          <>
            <tr
              className='h3'
              style={{ textAlign: 'left' }}
            >
              <th colSpan={3}>Subscription Products</th>
            </tr>
            <tr style={{ textAlign: 'left' }}>
              <th>Product</th>
              <th>Quantity</th>
              <th>Total</th>
            </tr>
          </>
        )}
        {cart?.items.map((item, index) => {
          if (!item.selling_plan_allocation) return null;
          return (
            <tr key={index}>
              <td>
                <CartTableProduct item={item} />
              </td>
              <td>
                <CartProductQuantity
                  item={item}
                  settings={settings}
                />
              </td>
              <td>{item.final_line_price / 100}</td>
            </tr>
          );
        })}

        {/* One-Time Purchase Section */}
        {cart?.items.filter((item) => !item.selling_plan_allocation).length > 0 && (
          <>
            <tr
              className='h3'
              style={{ textAlign: 'left' }}
            >
              <th colSpan={3}>One-Time Purchases</th>
            </tr>
            <tr style={{ textAlign: 'left' }}>
              <th>Product</th>
              <th>Quantity</th>
              <th>Total</th>
            </tr>
          </>
        )}
        {cart?.items.map((item, index) => {
          if (item.selling_plan_allocation) return null;
          return (
            <tr key={index}>
              <td>
                <CartTableProduct item={item} />
              </td>
              <td>
                <CartProductQuantity
                  item={item}
                  settings={settings}
                />
              </td>
              <td>{item.final_line_price / 100}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
